













































import { Vue, Component, Prop } from 'vue-property-decorator';

import { ILocation } from '@/models/location';

import { groupLocationsByCity } from '@/utils/groupLocationsByCity';

import MapIcon from '@/components/icons/Pin.vue';
import ArrowTopTurnRightIcon from '@/components/icons/ArrowTopTurnRight.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import { getLabelInfo } from '@/utils/getLabelInfo';

@Component({
  components: {
    ArrowTopTurnRightIcon,
    MapIcon,
    Typography
  }
})
export default class GroupedLocationsByCity extends Vue {
  @Prop({ default: () => [] }) locations!: Array<ILocation>;

  get groupedLocations(): Record<string, Array<ILocation>> {
    return groupLocationsByCity(this.locations);
  }

  getFullAddress(location: ILocation) {
    return getLabelInfo(
      ['address', 'addressAdditional', 'city', 'state', 'zip', 'country'],
      location
    );
  }
}
